import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { openBookingWidget } from "@/components/BookingButton";

const URL = "https://www.travelbackland.com/book";

export const Route = createFileRoute("/book")({
  head: () => ({
    meta: [
      { title: "Book Your Stay — Backland" },
      {
        name: "description",
        content: "Reserve your stay at Backland.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Book Your Stay — Backland" },
      { property: "og:url", content: URL },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "preconnect", href: "https://app.mews.com", crossOrigin: "anonymous" } as any,
      {
        rel: "preload",
        as: "script",
        href: "https://app.mews.com/distributor/distributor.min.js",
      } as any,
    ],
  }),
  component: BookPage,
});

function BookPage() {
  const navigate = useNavigate();
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    let done = false;
    const go = () => {
      if (done) return;
      done = true;
      observer.disconnect();
      window.clearTimeout(failsafe);
      window.clearTimeout(slowTimer);
      navigate({ to: "/", replace: true });
    };

    const isIframeVisible = (el: HTMLIFrameElement) => {
      const style = window.getComputedStyle(el);
      if (style.display === "none" || style.visibility === "hidden") return false;
      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    };

    const checkForMews = () => {
      const frames = document.querySelectorAll<HTMLIFrameElement>("iframe.mews-distributor");
      for (const f of frames) {
        if (isIframeVisible(f)) {
          go();
          return true;
        }
      }
      return false;
    };

    // Watch the DOM for the Mews iframe to actually mount and become visible.
    const observer = new MutationObserver(() => {
      checkForMews();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    // Safety net: if Mews never opens, don't strand the guest on the splash.
    const failsafe = window.setTimeout(go, 4000);
    const slowTimer = window.setTimeout(() => setSlow(true), 2000);

    // Fire-and-forget: kick off the widget. The observer above handles the
    // actual navigation once the iframe is visibly on screen.
    openBookingWidget().catch(() => go());

    // In case Mews was already open from a prior visit.
    checkForMews();

    return () => {
      done = true;
      observer.disconnect();
      window.clearTimeout(failsafe);
      window.clearTimeout(slowTimer);
    };
  }, [navigate]);


  return (
    <div className="fixed inset-0 bg-background text-foreground flex items-center justify-center z-[60]">
      <div className="text-center px-6">
        <div className="text-[10px] tracking-[0.4em] uppercase text-gold/90 mb-3">
          Backland
        </div>
        <p className="font-serif text-xl md:text-2xl text-foreground/85">
          Opening reservations…
        </p>
        {slow && (
          <p className="mt-3 text-xs text-foreground/50">
            Taking longer than usual…
          </p>
        )}
      </div>
    </div>
  );
}

